<div class="dashboard-container container-fluid px-0">
  <div class="row g-0 vh-100 overflow-hidden">
    <div
      v-if="!is_mobile"
      class="col-auto sidebar-wrapper d-flex flex-column flex-shrink-0 vh-100 overflow-hidden"
      :class="{ 'sidebar-collapsed': sidebar_collapsed }"
    >
      <PropertySidebar
        v-if="sidebar_active_property"
        :active_property="sidebar_active_property"
        :properties="sidebar_tiles"
        :active_item="sidebar_active_item"
        :can_view_portfolio="sidebar_can_view_portfolio"
        @switch-property="open_sidebar_property"
        @go-back="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
      />
      <PortfolioSidebar
        v-else
        :tiles="sidebar_tiles"
        @tile-clicked="open_sidebar_property"
        @global-menu-selected="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
        @global-selected="open_sidebar_portfolio"
      />
    </div>

    <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay" @click.self="mobile_sidebar_open = false">
      <div class="mobile-sidebar-panel h-100 overflow-hidden">
        <PropertySidebar
          v-if="sidebar_active_property"
          :active_property="sidebar_active_property"
          :properties="sidebar_tiles"
          :active_item="sidebar_active_item"
          :can_view_portfolio="sidebar_can_view_portfolio"
          @switch-property="open_sidebar_property"
          @go-back="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PropertySidebar>
        <PortfolioSidebar
          v-else
          :tiles="sidebar_tiles"
          @tile-clicked="open_sidebar_property"
          @global-menu-selected="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
          @global-selected="open_sidebar_portfolio"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PortfolioSidebar>
      </div>
    </div>

    <button v-if="!is_mobile" class="sidebar-collapse-btn btn btn-sm btn-dark" @click="sidebar_collapsed = !sidebar_collapsed">
      <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
    </button>

    <div class="col vh-100 d-flex flex-column overflow-hidden no-scrollbar edit-profile-shell">
    <HeaderSection 
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @toggle-mobile-sidebar="toggle_mobile_sidebar"
    />

<div class="container-fluid p-0 edit-profile-page flex-grow-1 min-h-0">

    <div v-if="form_error" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
        <div class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ form_error }}</div>
                <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_form_error"></button>
            </div>
        </div>
    </div>

    <!-- MAIN -->
    <section class="container py-4">

        <div class="glass-card p-4 rounded-4">

            <h4 class="text-white fw-bold mb-4">{{ page_title }}</h4>

            <form novalidate @submit.prevent="saveProfile">
                <div class="row g-4">

                    <!-- Avatar -->
                    <div class="col-md-2 text-center text-md-start mb-3 mb-md-0">
                        <div class="profile-avatar d-flex align-items-center justify-content-center mx-auto mx-md-0">
                            <span class="profile-avatar-text">{{ avatar_initials }}</span>
                        </div>

                    </div>

                    <!-- Form Fields -->
                    <div class="col-md-9">

                        <div class="row g-3">

                            <!-- First Name -->
                            <div class="col-md-6">
                                <label for="edit-profile-first-name" class="form-label text-white-50">First Name</label>
                                <input 
                                    id="edit-profile-first-name"
                                    ref="first_name_input"
                                    type="text" 
                                    :class="['form-control form-control-dark', field_errors.first_name ? 'border-danger' : '']"
                                    placeholder="Enter first name"
                                    v-model="form.first_name"
                                    autocomplete="given-name"
                                    :aria-invalid="field_errors.first_name ? 'true' : 'false'"
                                    :aria-describedby="field_errors.first_name ? 'edit-profile-first-name-error' : null"
                                    required
                                    @input="validate_field('first_name', false)"
                                    @blur="validate_field('first_name')"
                                >
                                <div v-if="field_errors.first_name" id="edit-profile-first-name-error" class="invalid-feedback d-block text-xs">
                                    {{ field_errors.first_name }}
                                </div>
                            </div>

                            <!-- Last Name -->
                            <div class="col-md-6">
                                <label for="edit-profile-last-name" class="form-label text-white-50">Last Name</label>
                                <input 
                                    id="edit-profile-last-name"
                                    ref="last_name_input"
                                    type="text" 
                                    :class="['form-control form-control-dark', field_errors.last_name ? 'border-danger' : '']"
                                    placeholder="Enter last name"
                                    v-model="form.last_name"
                                    autocomplete="family-name"
                                    :aria-invalid="field_errors.last_name ? 'true' : 'false'"
                                    :aria-describedby="field_errors.last_name ? 'edit-profile-last-name-error' : null"
                                    required
                                    @input="validate_field('last_name', false)"
                                    @blur="validate_field('last_name')"
                                >
                                <div v-if="field_errors.last_name" id="edit-profile-last-name-error" class="invalid-feedback d-block text-xs">
                                    {{ field_errors.last_name }}
                                </div>
                            </div>

                            <!-- Email -->
                            <div class="col-md-6">
                                <label for="edit-profile-email" class="form-label text-white-50">Email Address</label>
                                <input 
                                    id="edit-profile-email"
                                    type="email" 
                                    class="form-control form-control-dark"
                                    placeholder="name@example.com"
                                    v-model="form.email"
                                    readonly
                                >
                            </div>

                            <!-- Phone -->
                            <div class="col-md-6">
                                <label for="edit-profile-phone" class="form-label text-white-50">Phone Number</label>
                                <input 
                                    id="edit-profile-phone"
                                    ref="phone_input"
                                    type="tel"
                                    name="phone"
                                    pattern="[0-9]{10}"
                                    inputmode="numeric"
                                    placeholder="0123456789"
                                    :class="['form-control form-control-dark', field_errors.phone ? 'border-danger' : '']"
                                    v-model="form.phone"
                                    autocomplete="tel-national"
                                    :aria-invalid="field_errors.phone ? 'true' : 'false'"
                                    :aria-describedby="field_errors.phone ? 'edit-profile-phone-error' : null"
                                    required
                                    @input="validate_field('phone', false)"
                                    @blur="validate_field('phone')"
                                >
                                <div v-if="field_errors.phone" id="edit-profile-phone-error" class="invalid-feedback d-block text-xs">
                                    {{ field_errors.phone }}
                                </div>
                            </div>

                            <!-- Session Policy -->
                            <div v-if="is_managed_user_edit" class="col-md-6">
                                <label for="edit-profile-session" class="form-label text-white-50">Session Policy</label>
                                <select
                                    id="edit-profile-session"
                                    v-model="form.session_policy"
                                    class="form-select form-select-dark"
                                    aria-describedby="edit-profile-session-hint"
                                    :disabled="is_loading || is_saving"
                                    @change="handle_session_policy_change"
                                >
                                    <option value="default">Default</option>
                                    <option value="custom">Custom timeout</option>
                                    <option value="unlimited">Unlimited</option>
                                </select>
                                <div id="edit-profile-session-hint" class="text-white-50 text-xs mt-2">
                                    {{ session_policy_hint }}
                                </div>
                            </div>

                            <!-- Session Timeout -->
                            <div v-if="is_managed_user_edit && form.session_policy === 'custom'" class="col-md-6">
                                <label for="edit-profile-session-timeout" class="form-label text-white-50">Timeout (minutes)</label>
                                <input
                                    id="edit-profile-session-timeout"
                                    ref="session_timeout_input"
                                    type="number"
                                    min="1"
                                    :max="max_session_timeout_minutes"
                                    step="1"
                                    inputmode="numeric"
                                    placeholder="e.g. 30"
                                    :class="['form-control form-control-dark', field_errors.session_timeout_minutes ? 'border-danger' : '']"
                                    v-model.number="form.session_timeout_minutes"
                                    :disabled="is_loading || is_saving"
                                    :aria-invalid="field_errors.session_timeout_minutes ? 'true' : 'false'"
                                    :aria-describedby="field_errors.session_timeout_minutes ? 'edit-profile-session-timeout-error' : null"
                                    required
                                    @input="validate_field('session_timeout_minutes', false)"
                                    @blur="validate_field('session_timeout_minutes')"
                                >
                                <div v-if="field_errors.session_timeout_minutes" id="edit-profile-session-timeout-error" class="invalid-feedback d-block text-xs">
                                    {{ field_errors.session_timeout_minutes }}
                                </div>
                            </div>

                            <div v-if="is_managed_user_edit" class="col-12">
                                <div class="d-flex align-items-center justify-content-between gap-3 mb-2">
                                    <label class="form-label text-white-50 mb-0">Assigned Properties</label>
                                    <span class="badge rounded-pill settings-soft-badge text-xs">
                                        {{ selected_property_count }} selected
                                    </span>
                                </div>

                                <div v-if="is_loading_properties" class="settings-property-picker-empty rounded-3 text-white-50 text-xs">
                                    Loading properties...
                                </div>

                                <div v-else-if="!property_options.length" class="settings-property-picker-empty rounded-3 text-white-50 text-xs">
                                    No active properties available.
                                </div>

                                <div v-else class="settings-property-picker">
                                    <button
                                        v-for="property in property_options"
                                        :key="property.id"
                                        type="button"
                                        ref="propertyButtons"
                                        class="settings-property-option"
                                        :class="[{ 'is-selected': is_property_selected(property.id) }, field_errors.property_ids ? 'border-danger' : '']"
                                        :aria-pressed="is_property_selected(property.id)"
                                        :aria-invalid="field_errors.property_ids ? 'true' : 'false'"
                                        @click="toggle_property(property.id)"
                                    >
                                        <span class="settings-property-check" aria-hidden="true">
                                            <i v-if="is_property_selected(property.id)" class="bi bi-check-lg"></i>
                                        </span>
                                        <span class="settings-property-name">{{ property.name }}</span>
                                    </button>
                                </div>
                                <div v-if="field_errors.property_ids" class="invalid-feedback d-block text-xs mt-2">
                                    {{ field_errors.property_ids }}
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <!-- BUTTONS -->
                <div class="d-flex justify-content-end mt-4 gap-3">
                    <button 
                        type="button" 
                        class="btn btn-outline-light btn-sm rounded-3 px-2 py-1 fw-light text-xs"
                        @click="cancelEdit"
                    >
                        Cancel
                    </button>

                    <button 
                        type="submit" 
                        class="btn btn-primary btn-sm rounded-3 px-3 py-1 fw-light text-xs"
                    >
                        Save Changes
                    </button>
                </div>

            </form>

        </div>

    </section>

</div>
    </div>
  </div>
</div>
